import { ArrowUpRight, Luggage, Signal, ShieldCheck, Map } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { TOOLS } from "@/data/content";

const ICONS = { Luggage, Signal, ShieldCheck, Map };

export default function TravelTools() {
  return (
    <section id="tools" data-testid="travel-tools-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
      <Reveal className="max-w-2xl">
        <Eyebrow>Travel Tools</Eyebrow>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight">
          Travel tools that earn their place
        </h2>
        <p className="mt-4 text-base text-charcoal/75 leading-relaxed">
          Luggage, eSIMs, insurance, packing systems, airport tools, and trip-planning resources selected for
          usefulness, not hype.
        </p>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {TOOLS.map((t, i) => {
          const Icon = ICONS[t.icon];
          return (
            <Reveal key={t.testid} delay={i * 0.08}>
              <a
                href={t.url}
                target="_blank"
                rel="noopener noreferrer sponsored"
                data-testid={t.testid}
                className="group flex flex-col h-full rounded-3xl bg-white border border-slateblue/15 p-7 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_-16px_rgba(16,42,67,0.16)] hover:border-gold/40"
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-navy text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-navy">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-6 font-serif text-xl text-navy">{t.title}</h3>
                <p className="mt-3 text-sm text-charcoal/70 leading-relaxed flex-1">{t.blurb}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.14em] uppercase text-ocean group-hover:text-gold transition-colors duration-300">
                  {t.cta}
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
